import React from 'react';
import { HeroBanner } from '../components/home/HeroBanner';
import { BrandPhilosophy } from '../components/home/BrandPhilosophy';
import { ProductRangesPreview } from '../components/home/ProductRangesPreview';
import { ZwheelExperience } from '../components/home/ZwheelExperience';
import { FeaturedProducts } from '../components/home/FeaturedProducts';
import { AccessoriesPartsPreview } from '../components/home/AccessoriesPartsPreview';
import { TechInnovation } from '../components/home/TechInnovation';
import { LatestBlogPosts } from '../components/home/LatestBlogPosts';
import { CTASection } from '../components/home/CTASection';
import { useSEO } from '../hooks/useSEO';

function Home() {
  useSEO({
    title: 'Patinetes Eléctricos y Movilidad Urbana',
    description: 'Descubre la gama de patinetes eléctricos ZWheel. Potencia, autonomía y tecnología para tu día a día.',
    keywords: 'patinetes eléctricos, movilidad urbana, scooter eléctrico, zwheel'
  });

  return (
    <div className="bg-white overflow-x-hidden">
      {/* 1.1 - 1.2: Video Hero & Logo */}
      <HeroBanner />

      {/* 1.3: Brand Philosophy & Values */}
      <BrandPhilosophy />

      {/* 1.4: Product Ranges Preview */}
      <ProductRangesPreview />

      {/* 1.5 - 1.6: Zwheel Experience & Tech Centers */}
      <ZwheelExperience />

      {/* 1.7: Featured Products */}
      <FeaturedProducts />

      {/* 1.75: Accessories & Parts */}
      <AccessoriesPartsPreview />

      {/* 1.8: Tech Innovation */}
      <TechInnovation />

      {/* 1.10: Latest Blog Posts */}
      <LatestBlogPosts />

      {/* 1.11: Final CTA */}
      <CTASection />
    </div>
  );
}

export default Home;
